export default __webpack_public_path__ + "static/media/PF.7568f8b8.svg";